import PanelMenu from "./PanelMenu.js"
import CaptionSettings from "./CaptionSettings.js"
import Quality from "./Quality.js"
import PlaybackRate from "./PlaybackRate.js"
import AudioTracks from "./AudioTracks.js"
import ListItem from "./ListItem.js"
import Utils from "./Utils.js"

export default class SettingsPanel extends PanelMenu {

  constructor(props, context) {
    super(props, context)
    this.state.settingsLevel = 0
    this.state.bitrateLabel = "Auto"
    this.state.captioningSettingState = null
  }

  static get contextTypes() {
    return super.contextTypes
  }

  onready(event) {
    this.setState({"autoplay": this.player.autoplay})
  }

  onseeked(event) {
  	this.open = false
  }

  toggle() {
    super.toggle()
    this.state.settingsLevel = 0
  }

  onqualitychanging(event) {
    let brLabel = this.player.qualityMode === "auto" ? "Auto" : (Math.round(event.detail.bitrate / 1000) + "Kbps") // TODO: Needs to be localized
    this.state.quality = this.state.qualityLevels ? this.state.qualityLevels.findIndex(levelObject => levelObject.qualityIndex == event.detail.qualityIndex && levelObject.level == event.detail.level) : -1
    this.setState({bitrateLabel: brLabel})
  }

  changeState(value, event) {
    if (event.type == "keydown" && (event.keyCode == 13 || event.keyCode == 32 || event.keyCode == 37 || event.keyCode == 38 || event.keyCode == 39 || event.keyCode == 40) && this.mouseFocus != true) {
      if (event.keyCode == 37 && this.state.settingsLevel == 0)
        return
      this.state.keyDown = true
    }
    setTimeout(() => { this.setState({settingsLevel:value});}, 100)
  }

  autoplayToggle() {
    this.setState({"autoplay": (this.player.autoplay = !this.player.autoplay)})
  }

  componentWillUpdate(nextProps, nextState) {
    if(nextState.settingsLevel == 1 && this.refs.firstElem.state.captionsettings)
      this.setState({'captioningSettingState': this.refs.firstElem.state.captionsettings})
    else if ((this.refs.firstElem != null) && !isNaN(this.refs.firstElem.state.activeIndex))
      this.setState({'playbackSettingState': this.refs.firstElem.state.activeIndex})
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.keyDown) {
      if (typeof this.refs.firstElem.focus === "function") {
        this.refs.firstElem.focus()
      }
      else {
        this.refs.firstElem.refs.element.childNodes[1].focus()
      }
      this.state.keyDown = false
    }
  }

  currentAudioTrackLabel () {
    let audioTracks = this.player.audioTracks
    for (var i=0; i<audioTracks.length; i++) {
      let item = audioTracks[i]
      if ( item != null && item.enabled) {
        const lang = this.player.localization.getLanguageString(item.language) || item.language
      	const label = item.label || lang || item.id || this.player.localization.getString("MSG_UNKNOWN")
        return label
        console.log("xxxx")
      }
    }
    return ""
  }

  render() {
    switch (this.state.settingsLevel) {
      case 0:
        const isCaptionEnabled = Utils.componentEnabled(this.plugin, "captioning")
        const isQualityEnabled = this.player.qualityLevels != null && this.player.qualityLevels.length > 1
        const audioTracksAvailable = this.player.audioTracks != null && this.player.audioTracks.length > 1
        let qualityRef, playbackRef
        if (!isCaptionEnabled && isQualityEnabled)
          qualityRef = "firstElem"
        else if (!isCaptionEnabled && !isQualityEnabled)
          playbackRef = "firstElem"

        return (<div ref="element" {...this.propsList} className={`amp-settings amp-panel ${this.className}`} role="menu">
                { isCaptionEnabled &&
                  <ListItem ref="firstElem" className="amp-subtitles" onClick={this.changeState.bind(this, 1)} direction="right">
                    <span className="amp-label">Subtitles</span>
                    <button className="amp-icon amp-icon-right amp-right" tabIndex="-1"></button>
                    <span className="amp-right">{this.player.captioning.hidden ? "Off": this.player.localization.getLanguageString(this.player.captioning.track.language)}</span>
                  </ListItem>
                }
                { isQualityEnabled &&
                  <ListItem ref={qualityRef} onClick={this.changeState.bind(this, 2)} direction="right">
                    <span className="amp-label">Quality</span>
                    <button className="amp-icon amp-icon-right amp-right" tabIndex="-1"></button>
                    <span className="amp-right">{this.state.bitrateLabel}</span>
                  </ListItem>
                }
                { this.player.mode != "flash" &&
                  <ListItem ref={playbackRef} className="amp-playback-rate-button" onClick={this.changeState.bind(this, 3)} direction="right">
                    <span className="amp-label">Speed</span>
                    <button className="amp-icon amp-icon-right amp-right" tabIndex="-1"></button>
                    <span className="amp-right">{this.player.playbackRate === 1 ? 'Normal' : this.player.playbackRate}</span>
                  </ListItem>
                }
                { audioTracksAvailable &&
                  <ListItem ref="audiotracks" className="amp-playback-rate-button" direction="right" onClick={this.changeState.bind(this, 4)}>
                    <span className="amp-label">Audio</span>
                    <button className="amp-icon amp-icon-right amp-right" tabIndex="-1"></button>
                    <span className="amp-right">{this.currentAudioTrackLabel()}</span>
                  </ListItem>
                }
                {
                  <ListItem ref="autoplay" className={this.state.autoplay?"amp-autoplay-on":"amp-autoplay-off"} direction="right" onClick={this.autoplayToggle.bind(this)}>
                    <span className="amp-label">Autoplay</span>
                    <button className="amp-right amp-icon amp-toggle"></button>
                  </ListItem>
                }
               </div>)
        break
      case 1:
        return (<div ref="element" className={`amp-captioning-settings amp-panel ${this.className}`}>
                  <CaptionSettings ref="firstElem" captionState={this.state.captioningSettingState} gotoSettings={this.changeState.bind(this,0)}/>
                </div>)
        break
      case 2:
        return (<div ref="element" className={`amp-bitrate amp-panel ${this.className}`}>
                  <Quality ref="firstElem" gotoSettings={this.changeState.bind(this,0)} />
                </div>)
        break
      case 3:
        return (<div ref="element" className={`amp-playback-rate amp-panel ${this.className}`}>
                  <PlaybackRate ref="firstElem" gotoSettings={this.changeState.bind(this,0)} />
                </div>)
        break
      case 4:
        return (<div ref="element" className={`amp-audio-tracks amp-panel ${this.className}`}>
                  <AudioTracks ref="firstElem" gotoSettings={this.changeState.bind(this,0)} />
                </div>)
        break
    }

  }
}
